/* eslint-disable node/no-deprecated-api */
module.exports = function (size) {
  if (typeof Buffer.allocUnsafe === 'function') {
    try {
      return Buffer.allocUnsafe(size)
    } catch (e) {
      return new Buffer(size)
    }
  }
  return new Buffer(size)
}



//////////////////
// WEBPACK FOOTER
// ./~/swarm-js/~/fs-extra/lib/util/buffer.js
// module id = 753
// module chunks = 0 1 3